import { gsap } from 'gsap';

const animationTiming = {
  duration: 0.4,
  easing: 'power3.out'
};

const closeAnimation = (content, element) => gsap.to(content, {
  height: 0,
  ...animationTiming,
  overwrite: true,
  onComplete: () => {
    element.removeAttribute('open');
  },
});


const openAnimation = content => gsap.fromTo(
  content,
  {
    height: 0,
  },
  {
    height: 'auto',
    ...animationTiming,
    overwrite: true,
  }
);

const init = () => {
  const accordion = document.querySelectorAll('.js-accordion');
  const OPEN_CLASS = 'is-open';

  accordion.forEach(element => {
    const trigger = element.querySelector('.js-accordion-trigger');
    const target = element.querySelector('.js-accordion-target');
    const isSetBreakpoint = element.getAttribute('data-accordion-breakpoint');

    const textElement = trigger.querySelector('.js-accordion-trigger-text');
    let buttonText = '';

    closeAnimation(target, element).restart();

    const handleClick = (event) => {
      event.preventDefault();
      const isOpen = element.classList.contains(OPEN_CLASS);

      if (isOpen) {
        element.classList.toggle(OPEN_CLASS);
        element.setAttribute('open', 'false');
        closeAnimation(target, element).restart();
      } else {
        element.setAttribute('open', 'true');
        element.classList.toggle(OPEN_CLASS);

        openAnimation(target).restart();
      }


      if (textElement) {
        buttonText = textElement.textContent;
        textElement.textContent = textElement.dataset.changeText;
        textElement.dataset.changeText = buttonText;
      }
    };

    trigger.addEventListener('click', handleClick);

    if (isSetBreakpoint) {
      const BREAK_POINT = Number(isSetBreakpoint);
      const mediaQuery = window.matchMedia(`(min-width: ${BREAK_POINT}px)`);

      const handleChange = mediaQuery => {
        const isBreakpoint = mediaQuery.matches;
        if (isBreakpoint) {
          element.classList.add(OPEN_CLASS);
          element.setAttribute('open', 'true');
          openAnimation(target).progress(1).play();
        } else {
          element.classList.remove(OPEN_CLASS);
          element.setAttribute('open', 'false');
          closeAnimation(target, element).progress(1).play();
        }
      };

      handleChange(mediaQuery);
      mediaQuery.addEventListener('change', handleChange);
    }


  });
};

export default init;
